import { ContadorDiasResult } from "../Contador-dias";
export const ContadorTable = ({ results }: { results: ContadorDiasResult }) => {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Evento</th>
            <th className="px-4 py-2 text-center truncate">Valores</th>
          </tr>
        </thead>
        <tbody>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Dias úteis
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.diasUteis}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Dias corridos
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.diasCorridos}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">Sábado</td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.sabados}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Domingos
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.domingos}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Feriados nacionais
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.feriados}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
